import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatErr } from "../lib/api";
import { useAuth } from "../lib/auth";
import Navbar from "../components/Navbar";
import { toast } from "sonner";
import { Check } from "lucide-react";

export default function Onboarding() {
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [settori, setSettori] = useState([]);
  const [sector, setSector] = useState("");
  const [threshold, setThreshold] = useState(3000);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/settori").then(r => setSettori(r.data.settori));
  }, []);

  const submit = async () => {
    if (!sector) { setErr("Seleziona un settore"); return; }
    setErr(""); setLoading(true);
    try {
      await api.post("/onboarding", { sector, threshold_eur: Number(threshold) });
      await refresh();
      toast.success("Configurazione completata");
      nav("/autorizza-fatture");
    } catch (ex) {
      setErr(formatErr(ex.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <Navbar />
      <div className="max-w-3xl mx-auto px-6 py-16">
        <div className="label-caps mb-3">Configurazione iniziale · Passo 1 di 1</div>
        <h1 className="font-serif-display text-4xl text-[#1E3F33]">Il tuo settore di attività</h1>
        <p className="mt-3 text-[#6B6B6B]">Applicheremo automaticamente le regole di detraibilità IVA più comuni per il tuo tipo di attività. Potrai sempre modificarle sui singoli movimenti.</p>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
          {settori.map((s) => (
            <button key={s} data-testid={`sector-${s}`} onClick={()=>setSector(s)}
              className={`card-flat p-4 text-left btn-lift ${sector===s ? "border-[#1E3F33] ring-1 ring-[#1E3F33]" : ""}`}>
              <div className="flex items-start gap-3">
                <div className={`mt-0.5 w-5 h-5 rounded-full grid place-items-center ${sector===s ? "bg-[#1E3F33] text-white" : "border border-[#EBE5DF]"}`}>
                  {sector===s && <Check size={12} />}
                </div>
                <span className="font-medium">{s}</span>
              </div>
            </button>
          ))}
        </div>

        <div className="mt-10 card-flat p-6">
          <label className="label-caps">Soglia di allerta (in €)</label>
          <p className="text-sm text-[#6B6B6B] mt-1 mb-3">Sarai avvisato quando il saldo IVA stimato supera questo importo.</p>
          <input data-testid="threshold-input" type="number" min="0" step="100" value={threshold} onChange={e=>setThreshold(e.target.value)}
            className="w-full max-w-xs px-3 py-2 border border-[#EBE5DF] rounded-md bg-white focus:outline-none focus:border-[#1E3F33]"/>
        </div>

        {err && <div data-testid="onboarding-error" className="mt-4 text-sm text-[#A83C22]">{err}</div>}

        <div className="mt-8 flex gap-3">
          <button data-testid="onboarding-submit" onClick={submit} disabled={loading}
            className="btn-lift px-6 py-3 bg-[#1E3F33] text-white rounded-md hover:bg-[#152D24] disabled:opacity-60">
            {loading ? "Salvataggio…" : "Continua"}
          </button>
        </div>
        <p className="mt-4 text-xs text-[#6B6B6B]">Nel passo successivo potrai autorizzare l'accesso automatico alle tue fatture.</p>
      </div>
    </div>
  );
}
